import React from 'react';
import styled, { css } from 'styled-components';
import { Flex } from '../Flex';
import { withPaddings } from '../../mixins';
import { containerDefaultProps } from './props';
const withType = ({ type = containerDefaultProps.type, }) => {
    const types = {
        outlined: css `
      border: var(--border-width-hairline) solid var(--container-border-color-outlined);
    `,
        elevated: css `
      box-shadow: var(--shadow-level-3);
    `,
    };
    return types[type];
};
export const ContainerWrapper = styled((props) => {
    return React.createElement(Flex, Object.assign({ "data-ds-component": "DS-Container" }, props));
}) `
  background-color: var(--container-background-color);
  border-radius: var(--border-radius-sm);
  padding: var(--spacing-2);
  overflow: hidden;
  ${withType}
  ${withPaddings}
`;
